import {
  DeleteFilled,
  DollarCircleFilled,
  ExperimentFilled,
  QuestionCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons'
import { modes, paneModes } from '@constants/orderWizard'
import { Col, Input, Popconfirm, Divider } from 'antd'
import React, { useMemo, useState } from 'react'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { isTruckLoaded } from '../../../../util'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'

export const EditOrderButtons = ({ cancelOrder, resetOrder, showOrderResetBtn, isCarrier }) => {
  const [note, setNote] = useState('')
  const { mode, setMode, setPaneMode, wizardOrder, isComplete } = useWizardMaster()
  const orderState = wizardOrder.state

  const canCancelOrder = useMemo(() => orderState === 'accepted' || wizardOrder?.can_cancel, [orderState, wizardOrder])
  const title = isCarrier
    ? 'Are you sure you want to reset this order? This will remove all logged driver/carrier information and any saved BOL/Delivery information.'
    : 'Are you sure to reset this order? This will remove all driver information logged.'

  return (
    <>
      {orderState !== 'complete' && (
        <>
          <GraviButton
            size='large'
            theme2
            appearance='outlined'
            icon={<ExperimentFilled />}
            buttonText='Destinations / Products'
            onClick={() => {
              mode === modes.VIEW && setMode(modes.EDIT)
              setPaneMode(paneModes.PRODUCTSELECT)
            }}
          />
          <GraviButton
            disabled={isTruckLoaded(wizardOrder.trip_status)}
            size='large'
            theme2
            appearance='outlined'
            icon={<DollarCircleFilled />}
            buttonText='Supply Options'
            onClick={() => {
              mode === modes.VIEW && setMode(modes.EDIT)
              setPaneMode(paneModes.SUPPLYFILTERS)
            }}
          />
        </>
      )}

      {canCancelOrder && (
        <Popconfirm
          icon={<QuestionCircleOutlined />}
          title='Are you sure?'
          description={
            <Vertical gap={8}>
              <Texto> Once an order is canceled, it cannot be reverted.</Texto>
              <Divider className='my-1' orientation='left' plain>
                Cancel Note:
              </Divider>
              <Input
                width='100%'
                placeholder='Add a note'
                allowClear
                onChange={(e) => setNote(e.target.value)}
                value={note}
              />
            </Vertical>
          }
          onConfirm={() => cancelOrder(isComplete, note)}
          okText='Yes'
          cancelText='No'
        >
          <GraviButton size='large' error appearance='outlined' icon={<DeleteFilled />} buttonText='Cancel Order' />
        </Popconfirm>
      )}

      <Popconfirm title={title} onConfirm={() => resetOrder(isComplete)} okText='Yes' cancelText='No'>
        {showOrderResetBtn && (
          <GraviButton size='large' error appearance='outlined' icon={<RedoOutlined />} buttonText='Reset Order' />
        )}
      </Popconfirm>
    </>
  )
}
